import { render } from "./responsibility.vue?vue&type=template&id=f64d9f9a&scoped=true&ts=true"
import script from "./responsibility.vue?vue&type=script&lang=ts"
export * from "./responsibility.vue?vue&type=script&lang=ts"

import "./responsibility.vue?vue&type=style&index=0&id=f64d9f9a&lang=scss&scoped=true"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f64d9f9a"]])

export default __exports__